

















































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { Chapter, Course, LoggedOutCoupon, User } from 'frontend/types';
import { postData } from 'frontend/utils/ajax';
import Cover from 'frontend/views/courses/CoursePage/components/Cover.vue';
import ChaptersList from 'frontend/views/courses/CoursePage/components/ChaptersList.vue';
import DetailedDescription from 'frontend/views/courses/CoursePage/components/DetailedDescription.vue';
import OnboardingOverlay from 'frontend/views/courses/CoursePage/components/OnboardingOverlay.vue';
import CourseModal from 'frontend/views/courses/CoursePage/components/CourseModal.vue';
import LLPOnboardingModal from 'frontend/views/learningPathV2/LLPOnboardingModal.vue';
import { LearningPathCourse } from 'frontend/store/modules/next-learning-path-course';
import LLPDaisyChain from './components/LLPDaisyChain.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import { track } from 'frontend/utils/analytics';

@Component({
  components: {
    ChaptersList,
    CourseModal,
    Cover,
    DetailedDescription,
    OnboardingOverlay,
    LLPDaisyChain,
    LLPOnboardingModal,
    LoggedOutCouponBanner: () =>
      // tslint:disable-next-line:space-in-parens max-line-length
      import(
        /* webpackChunkName: 'LoggedOutCouponBanner' */ 'frontend/views/courses/components/LoggedOutCouponBanner.vue'
      ),
  },
  computed: {
    ...mapState('course', ['course']),
    ...mapState('globals', ['user']),
    ...mapState('isFirstCourse', ['didNotStartALesson']),
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('chapters', ['chapters']),
    ...mapGetters('showShoppingVersion', ['showShoppingVersion']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('loggedOutCoupon', ['activeLoggedOutCoupon']),
    ...mapGetters('nextLearningPathCourse', ['nextLearningPathCourse']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
  },
})
export default class CoursePage extends Vue {
  private readonly isAuthenticated!: boolean;
  private readonly showShoppingVersion!: boolean;
  private readonly didNotStartALesson!: boolean;
  private readonly course!: Course;
  private readonly chapters!: Chapter[];
  private readonly activeLoggedOutCoupon!: LoggedOutCoupon;
  private readonly learningPath?: RelatedLearningPathInfo;
  private readonly nextLearningPathCourse?: LearningPathCourse;
  private readonly user!: User;

  private isOnboardingOverlayOpen: boolean = false;
  private isCourseModalOpen: boolean = false;
  private isLLPOnboardingModalOpen: boolean = false;

  private get isInLLPRolloutExperiment(): boolean {
    return !!this.learningPath;
  }

  private get hasPractice(): boolean {
    return this.chapters.some(chapter =>
      chapter.quizzes.some(lesson => lesson.practice_lessons.length),
    );
  }

  private get shouldHighlightFirstLesson(): boolean {
    return this.isAuthenticated && this.didNotStartALesson;
  }

  private get shouldShowLLPOnboardingModal(): boolean {
    return !!this.user.show_llp_onboarding_modal && this.isInLLPRolloutExperiment;
  }

  private get showLoggedoutCouponBanner(): boolean {
    return !this.isAuthenticated && !!this.activeLoggedOutCoupon;
  }

  @Watch('isLLPOnboardingModalOpen')
  onIsLLPOnboardingModalOpenChange() {
    if (this.isLLPOnboardingModalOpen) {
      postData('/api/v4/learning-paths/viewed-llp-onboarding');
    }
  }
  mounted(): void {
    if (this.shouldHighlightFirstLesson) {
      // This compensates some small layout shifts in the page when the page is loaded.
      setTimeout(() => (this.isOnboardingOverlayOpen = true), 500);
    }

    this.isLLPOnboardingModalOpen = this.shouldShowLLPOnboardingModal;

    track('ui', {
      action: 'viewed_icp',
    });
  }
}
